module.exports = new __parcel__URL__("mirewood-tavern.4e13ed7a.webp").toString();